import { render, staticRenderFns } from "./VoucherPrepositionsPhone.vue?vue&type=template&id=a831ca28&"
import script from "./VoucherPrepositionsPhone.vue?vue&type=script&lang=js&"
export * from "./VoucherPrepositionsPhone.vue?vue&type=script&lang=js&"
import style0 from "./VoucherPrepositionsPhone.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Ftips-phone&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports